/** Namespace `ownership` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const ownership = {
  loadFailed: "Không đọc được danh sách phụ trách.",
  assignFailed: "Không gán được chủ sở hữu.",
  createTeamFailed: "Không tạo được đội ngũ.",
  title: "Phân công phụ trách",
  intro: "Ai chịu trách nhiệm khi thứ này hỏng — khác với ai được làm gì trong hub.",
  explain:
    "Chủ = đội ngũ chịu trách nhiệm khi sản phẩm/dịch vụ hỏng. Mức tier_0/tier_1 bắt buộc có chủ — thiếu thì hiện « Chưa có chủ » và nằm trong « Cần xử lý » tới khi gán xong; tier_2/tier_3 « Không bắt buộc ». Chưa có đội thì bấm « Tạo đội ngũ », thêm người ở màn « Đội ngũ », rồi gán ở cột cuối.",
  createTeam: "Tạo đội ngũ",
  missingOwnersAfter:
    " đối tượng trọng yếu chưa có chủ. Mỗi cái đang là một mục trong hàng đợi « Cần xử lý », và mục đó ",
  missingOwnersStrong: "tự đóng",
  missingOwnersEnd: " khi gán chủ xong.",
  slug: "Slug",
  teamName: "Tên đội",
  create: "Tạo",
  assignAsKind: "Gán với vai trò",
  multipleOwners: "Mỗi đối tượng có thể có nhiều chủ với vai trò khác nhau.",
  "col.subject": "Đối tượng",
  "col.type": "Loại",
  "col.tier": "Mức",
  "col.owners": "Chủ hiện tại",
  "col.assignTeam": "Gán đội ngũ",
  "type.product": "Sản phẩm",
  "type.service": "Dịch vụ",
  noOwner: "Chưa có chủ",
  noOwnerTitle: "Mức tier_0/tier_1 bắt buộc có chủ — gán một đội ở cột cuối để đóng mục « Cần xử lý ».",
  notRequired: "Không bắt buộc",
  notRequiredTitle: "Mức tier_2/tier_3 không bắt buộc có chủ — gán nếu muốn.",
  noTeams: "Chưa có đội ngũ nào",
  noTeamsTitle: "Bấm « Tạo đội ngũ » ở đầu trang để tạo đội trước.",
  pickTeam: "Chọn đội…",
  noEditPermission: "Không có quyền sửa",
} as const;
